import { useContext } from 'react'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { useParams } from 'react-router-dom'
import AppView from './AppView'
import { PapsContext } from 'global/cnr/contexts/PapsContext'

const PageManager = ({ children }) => {

  const params = useParams()

  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}
  const { isLandingPage, view, viewKey } = paps_state ?? {}

  const _isLandingPage = true
  const _isView = !isLandingPage && !viewKey && view ? true : false
  const _isViewKey = !isLandingPage && viewKey && view ? true : false

  return <AppView />
  return <AppView aspProps_alt={{ trueView: 'teams', view: 'teams', viewKey: 'eWspXOmGIh2jin4C2waW' }} />

  return (
    <>
      {_isLandingPage && <AppView
        pageLevel="landing"
        isLanding={isLandingPage}
      />}

      {_isView && (
        <AppView
          view={view}
          pageLevel="item"
        />
      )}

      {_isViewKey && (
        <AppView
          view={view}
          viewKey={viewKey}
          pageLevel="itemKey"
        />
      )}
    </>
  )
}

export default PageManager